import { render, staticRenderFns } from "./_base-input.vue?vue&type=template&id=0f606c71&scoped=true"
import script from "./_base-input.vue?vue&type=script&setup=true&lang=js"
export * from "./_base-input.vue?vue&type=script&setup=true&lang=js"
import style0 from "./_base-input.vue?vue&type=style&index=0&id=0f606c71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f606c71",
  null
  
)

export default component.exports